import { render, staticRenderFns } from "./setRule.vue?vue&type=template&id=a3d906ce"
import script from "./setRule.vue?vue&type=script&lang=ts"
export * from "./setRule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports